export const Play = () => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M104.2 34C94.7 36.5 87 41 80 48c-7.2 7.2-11.5 14.7-14 24.6-2 7.6-2 11.4-2 183.8 0 193.5-.3 182.1 6.1 194.8 4.1 8.2 14.5 18.6 22.7 22.7 13.3 6.7 28.8 7.8 42.3 2.8 4.6-1.6 50-29.8 147.5-91.3 157.6-99.4 151.5-95.2 159.3-111.3 8.7-18 7.8-38.2-2.4-55.7-3.5-6-10.6-13.7-16-17.4-2.2-1.5-49-28.7-104-60.5-55-31.7-117.5-67.9-139-80.3-21.4-12.4-41.9-23.7-45.5-25-9.1-3.4-21.1-3.9-30.8-1.2z"/>
        </svg>
    )
}